export const SCORM_TRUE = 'true'
export const SCORM_FALSE = 'false'
export const STATE_NOT_INITIALIZED = 0
export const STATE_INITIALIZED = 1
export const STATE_TERMINATED = 2
export const LOG_LEVEL_DEBUG = 1
export const LOG_LEVEL_INFO = 2
export const LOG_LEVEL_WARNING = 3
export const LOG_LEVEL_ERROR = 4
export const LOG_LEVEL_NONE = 5
